<template>
	<CustomSelect :value="getValue" :options="companies" :placeholder="$t('company.select_placeholder')"
		@select="setSelectedCompany" @search="searchCompany" :trackBy="'name'" :show-load-more="companiesHasMore"
		@on-load-more="loadMoreCompanies" :loading="dropdownIsLoading" />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CustomSelect from '@/components/CustomSelect';

export default {
	components: {
		CustomSelect
	},

	props: {
		isMove: {
			type: Boolean,
			default: false
		},

		value: {
			type: Object,
			default: null
		}
	},

	data: () => ({
		companies: [],
		companiesHasMore: true,
		companiesPage: 1,
		companySearchQuery: '',
		dropdownIsLoading: false
	}),

	computed: {
		...mapGetters('user', ['getActiveCompany']),

		getValue() {
			return this.isMove ? this.value : this.getActiveCompany;
		}
	},

	created() {
		this.fetchCompanies();
	},

	methods: {
		...mapActions('user', ['setActiveCompany']),

		loadMoreCompanies() {
			this.companiesPage = this.companiesPage + 1;
			this.fetchCompanies();
		},

		searchCompany(search) {
			this.companySearchQuery = search;
			this.companies = [];
			this.companiesPage = 1;
			this.fetchCompanies();
		},

		async refetchCompanies() {
			this.companies = [];
			this.companiesPage = 1;
			await this.fetchCompanies();

			return this.companies;
		},

		setSelectedCompany(company) {
			if (!this.isMove) {
				this.setActiveCompany(company);
			}

			this.$emit('on-select', {...company});
		},

		async fetchCompanies() {
			try {
				const data = await this.$services.company.list({
					pageNumber: this.companiesPage,
					search: this.companySearchQuery
				}, {
					loading: val => {
						this.dropdownIsLoading = val;
					}
				});

				this.companiesHasMore = data._pagination.currentPage < data._pagination.totalPages;

				this.companies = [
					...this.companies,
					...data
				];
			} catch (error) {
				console.log(error);
			}
		}
	}
};
</script>
